export default __webpack_public_path__ + "static/joinlowd-0f188645ca88be64f56c12c9f1da97cf.jpg";